import { render, staticRenderFns } from "./ProductAndMaterialSearch.vue?vue&type=template&id=179176f4&scoped=true"
import script from "./ProductAndMaterialSearch.vue?vue&type=script&lang=ts"
export * from "./ProductAndMaterialSearch.vue?vue&type=script&lang=ts"
import style0 from "./ProductAndMaterialSearch.vue?vue&type=style&index=0&id=179176f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179176f4",
  null
  
)

export default component.exports